import { takeLatest, spawn, put } from 'redux-saga/effects';

import apiRequest, { apiSuccess } from 'utils/api';
import { truthty, falsy } from 'utils/functions';
import { appActions } from 'commons/reducer';
import { CARRIERS } from '../reducer';

function* getStateFromApi() {
  yield takeLatest(CARRIERS.GET_STATE_FROM_API, function* (action) {
    const response = yield apiRequest('api/v1/carriers', { method: 'get' });
    yield put(apiSuccess(CARRIERS.GET_STATE_FROM_API_SUCCESS, response));
  });
}

function* createCarrier() {
  yield takeLatest(CARRIERS.CREATE_CARRIER, function* (action) {
    yield put(appActions.setLoader('create-edit-carrier', true));
    const processedControls = {
      ...action.controls,
      name: action.controls.name.toUpperCase(),
    };
    const response = yield apiRequest('api/v1/carriers', {
      method: 'post',
      body: JSON.stringify(processedControls),
    });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(apiSuccess(CARRIERS.CREATE_CARRIER_SUCCESS, response));
    }
    yield put(appActions.setLoader('create-edit-carrier', false));
  });
}

function* editCarrier() {
  yield takeLatest(CARRIERS.EDIT_CARRIER, function* (action) {
    yield put(appActions.setLoader('create-edit-carrier', true));
    const processedControls = {
      ...action.controls,
      name: action.controls.name.toUpperCase(),
    };
    const response = yield apiRequest(`api/v1/carriers/${action.id}`, {
      method: 'put',
      body: JSON.stringify(processedControls),
    });
    if (truthty(response.error)) {
      yield put(appActions.setError(response.errorMsg));
    } else {
      yield put(apiSuccess(CARRIERS.EDIT_CARRIER_SUCCESS, response));
    }
    yield put(appActions.setLoader('create-edit-carrier', false));
  });
}

function* deleteCarrier() {
  yield takeLatest(CARRIERS.DELETE_CARRIER, function* (action) {
    yield put(appActions.setLoader('delete-carrier', true));
    const response = yield apiRequest(`api/v1/carriers/${action.id}`, { method: 'delete' });
    if (falsy(response.error)) {
      const item = Object.values(response)[0];
      yield put(apiSuccess(CARRIERS.DELETE_CARRIER_SUCCESS, { item, type: 'carriers' }));
    } else {
      yield put(appActions.setError(response.errorMsg));
    }
    yield put(appActions.setLoader('delete-carrier', false));
  });
}

export default function* saga() {
  yield spawn(getStateFromApi);
  yield spawn(deleteCarrier);
  yield spawn(createCarrier);
  yield spawn(editCarrier);
}
